import React from "react";

const VotingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FB19E2]/10 to-[#9F00FF]/10 flex flex-col items-center justify-center p-6">
      <h1 className="text-3xl sm:text-4xl font-bold text-purple-700 mb-4">
        🎵 Voting Arena
      </h1>
      <p className="text-gray-600 text-center max-w-md mb-8">
        Cast your votes for your favorite dance teams and help them climb to the top!
      </p>

      <button
        className="px-6 py-3 rounded-xl bg-gradient-to-r from-[#9F00FF] to-[#FB19E2] text-white font-medium hover:opacity-90 transition shadow-lg"
        onClick={() => alert("Voting feature coming soon!")}
      >
        Start Voting
      </button>
    </div>
  );
};

export default VotingPage;
